import moment from "moment";

/**
 * Parse a date string from the API, extracting only the calendar date (YYYY-MM-DD).
 *
 * The API returns dates as UTC ISO strings (e.g. "2025-06-09T05:00:00.000Z")
 * that have lost their original timezone offset. Parsing without an explicit
 * format causes moment.js to interpret in the browser's local timezone, which
 * can shift the date by one day across DST boundaries.
 *
 * Using the explicit "YYYY-MM-DD" format extracts only the date portion and
 * interprets it as local midnight, matching the member-facing logbook pattern.
 */
export function parseApiDate(date: string): moment.Moment {
  return moment(date, "YYYY-MM-DD");
}
